export default function Community() {
    return (
        <div style={{background:"rgb(32, 32, 48) ",height:document.documentElement.clientHeight}}>

            <div class="ms-5 text-light" >
                <div>


                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <h1>This is community page.</h1>
                <br/>
                <h1>Coming Soon.</h1>
                </div>
            </div>



        </div>

    )
}